// extracted by mini-css-extract-plugin
module.exports = {"root":"OfficesMain_root__AuTHl"};